import { Spin } from "antd"; // Import Spin for loading feedback
import { useEffect, useRef, useState } from "react";
import { VideoWrapper } from "components/video-wrapper";
import { getTimeStamps, getVideoRatio } from "./helpers";
import { SeekBarMulti } from "components/seek-bar-multi";
import { Download, Download2D, Download3D } from "icons";
import { Tabs } from "components/preview-history-multi/Tabs";
import { UseDownloadJsonBundle } from "pages/pg-history/use-download-json-bundle";
import styles from "./styles.module.scss";

const downloadOptions = [
  {
    icon: Download,
    key: "video",
  },
  {
    icon: Download2D,
    key: "2d",
  },
  {
    icon: Download3D,
    key: "3d",
  },
];

const downLoadBtnKeys = {
  video: "video",
  twoD: "2d",
  threeD: "3d",
  forces: "forces",
  calibJsonIcon: "calibJsonIcon",
};

export function PgVisualizeWrapper({
  fileId,
  visible,
  videoSrc,
  deviceType,
  frames,
  frameRate,
  totalFrames,
  extractionProgress,
}: any) {
  const visualizeContainerRef = useRef<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isReadyToPlay, setIsReadyToPlay] = useState(false);
  const [timestamps, setTimeStamps] = useState<any>();
  const [error, setError] = useState<any>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentFrame, setCurrentFrame] = useState(0);
  const containerHeight = visualizeContainerRef?.current?.clientHeight;

  const containerHeightFix: any = "calc(100dvh - 340px)";

  const [heightOfContainer, setHeightOfContainer] =
    useState(containerHeightFix);
  const [widthOfContainer, setWidthOfContainer] = useState<any>();
  const [playbackSpeed, setPlaybackSpeed] = useState("1x");
  const [playbackMode, setplaybackMode] = useState("standard");

  const { downloading, handleDownloadJson } = UseDownloadJsonBundle();

  const playbackModeArr = [
    {
      title: "Standard Playback",
      key: "standard",
    },
    {
      title: "Smooth Playback",
      key: "smooth",
    },
  ];

  useEffect(() => {
    if (videoSrc) {
      // setIsLoading(false);
      // setIsReadyToPlay(false);
      setTimeStamps(null);
      setError(null);
      setIsPlaying(false);
      setCurrentFrame(0);

      const totalTimestamps = getTimeStamps(frameRate, totalFrames);

      setTimeStamps(totalTimestamps);
      setIsLoading(false); // Set loading state to false regardless of success or error
    }
  }, [frameRate, totalFrames, videoSrc]);

  function handlePlay() {
    setIsPlaying((prevState) => !prevState);
  }
  function handlePreviousFrame() {
    setCurrentFrame((prevFrame) => prevFrame - 1);
    setIsPlaying(false);
  }

  function handleNextFrame() {
    setCurrentFrame((prevFrame) => prevFrame + 1);
    setIsPlaying(false);
  }

  function handleSliderChange(e: any) {
    const frameIndex = parseInt(e.target.value);
    setCurrentFrame(frameIndex);
  }

  function handleResizeWidth() {
    setWidthOfContainer(
      getVideoRatio(visualizeContainerRef?.current?.clientHeight)
    );
  }

  function handleResize() {
    setHeightOfContainer(containerHeightFix);
  }
  useEffect(() => {
    if (visualizeContainerRef?.current) {
      setWidthOfContainer(
        getVideoRatio(visualizeContainerRef?.current?.clientHeight)
      );
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleResizeWidth);
    return () => window.removeEventListener("resize", handleResizeWidth);
  }, []);

  function handlePlayBackSpeed(existingSpeed: any) {
    let newSpeed = "";
    switch (existingSpeed) {
      case "1x":
        newSpeed = "2x";
        break;
      case "2x":
        newSpeed = "4x";
        break;
      case "4x":
        newSpeed = "8x";
        break;
      default:
        newSpeed = "1x";
        break;
    }
    setPlaybackSpeed(newSpeed);
  }
  function getTimeInterval(playbackSpeed: any) {
    let intervalTime = 33;
    switch (playbackSpeed) {
      case "2x":
        intervalTime = intervalTime / 2;
        break;
      case "4x":
        intervalTime = intervalTime / 4;
        break;
      case "8x":
        intervalTime = intervalTime / 8;
        break;
    }
    return intervalTime;
  }
  const time = playbackMode === "smooth" ? getTimeInterval(playbackSpeed) : 120;

  useEffect(() => {
    if (!isPlaying) return;
    const interval = setInterval(() => {
      setCurrentFrame((prevFrame: any) => {
        const nextFrame = prevFrame + 1;
        const finalFrame = timestamps.length;
        const myFrame = nextFrame;

        if (myFrame >= finalFrame) {
          setIsPlaying(false);
          // Stop playback when reaching the last frame
          return 0;
        }
        return nextFrame;
      });
    }, time);

    return () => {
      clearInterval(interval);
    };
  }, [isPlaying, playbackSpeed]);

  function handleClickDownload(iconType: any) {
    const { video, twoD, threeD } = downLoadBtnKeys;
    switch (iconType) {
      case video:
        return handleDownloadJson({ fileId, type: "video" });
      case twoD:
        return handleDownloadJson({ fileId, type: "pose_2d" });
      case threeD:
        return handleDownloadJson({ fileId, type: "pose_3d" });

      default:
        break;
    }
  }

  return (
    <Spin
      spinning={!isReadyToPlay || downloading}
      style={{ maxWidth: widthOfContainer }}
    >
      <div
        className={styles.visualizeWrapperContainer}
        ref={visualizeContainerRef}
        style={{ width: widthOfContainer, height: heightOfContainer }}
      >
        <div style={{ position: "relative", height: "100%" }}>
          <VideoWrapper
            containerHeight={containerHeight}
            videoSrc={videoSrc}
            setIsReadyToPlay={setIsReadyToPlay}
            timestamps={timestamps}
            currentFrame={currentFrame}
            isPlaying={isPlaying}
            isLandscape={false}
            frameRate={frameRate}
            extractionProgress={extractionProgress}
            activeExtraction={playbackMode === "smooth"}
            frames={frames}
          />

          <div
            className={styles.switchTab}
            style={{
              width: "70%",
              position: "absolute",
              left: "10px",
              top: "10px",
              zIndex: "1",
            }}
          >
            <Tabs
              activeTab={playbackMode}
              setActiveTab={setplaybackMode}
              tabsArr={playbackModeArr}
              variant="pg-golf"
            />
          </div>

          <div style={{ position: "absolute", top: "10px", right: "10px" }}>
            <div className={styles.iconsWrapper}>
              {downloadOptions?.map((item) => (
                <item.icon
                  height={50}
                  width={50}
                  key={item.key}
                  onClick={() => handleClickDownload(item.key)}
                />
              ))}
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              bottom: "10px",
              left: "2%",
              width: "96%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <SeekBarMulti
              handleNextFrame={handleNextFrame}
              handleSliderChange={handleSliderChange}
              handlePreviousFrame={handlePreviousFrame}
              handlePlay={handlePlay}
              currentFrame={currentFrame}
              isReadyToPlay={!isLoading}
              isPlaying={isPlaying}
              timestamps={timestamps}
              playbackMode={playbackMode}
              handlePlayBackSpeed={handlePlayBackSpeed}
              playbackSpeed={playbackSpeed}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
}
